import React, {Component} from "react";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import ProductsList from "./views/ProductsList";
import ProductPropertiesPanel from "./panels/ProductPropertiesPanel";
import BundledProductsPanel from "./panels/BundledProductsPanel";
import FilterPanel from "../../components/panels/FilterPanel";
import {List, fromJS} from "immutable";

function isBundle(type) {
  return type === "bundle";
}

const productFilterOptions = fromJS([
  {id: "", label: "All Products"},
  {id: "water", label: "Water"},
  {id: "dispenser", label: "Dispensers"},
  {id: "extras", label: "Extras"},
  {id: "packaging", label: "Packaging"},
  {id: "bundle", label: "Bundles"},
])

class ProductsPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.state = {
      productId: "",
      productType: "",
      hasProductSelection: false,
      productFilter: "",
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    return (
      <div className="ProductsPage SecurePage">
        <AppSidebar />
        <PageHeader title="Products" />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Create product" 
              show={page === "products"}
              onClick={this.handleCreateProduct.bind(this)} />
            <ActionButton 
              label="Create product bundle" 
              show={page === "products"}
              onClick={this.handleCreateBundle.bind(this)} />
            <ActionButton 
              label="Change description" 
              show={page === "products"}
              active={this.state.hasProductSelection} 
              onClick={this.handleChangeDescription.bind(this)} />
            <ActionButton 
              label="Change measurements" 
              show={page === "products"}
              active={this.state.hasProductSelection && !isBundle(this.state.productType)} 
              onClick={this.handleChangeMeasurements.bind(this)} />
            <ActionButton 
              label="Add to bundle" 
              show={page === "products"}
              active={this.state.hasProductSelection && isBundle(this.state.productType)} 
              onClick={this.handleAddToBundle.bind(this)} />
            <ActionButton 
              label="Remove from bundle" 
              show={page === "products"}
              active={this.state.hasProductSelection && isBundle(this.state.productType)} 
              onClick={this.handleRemoveFromBundle.bind(this)} />
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    switch(page) {
      case "products":
        return (
          <ProductsList 
            key="ProductsList"
            productFilter={this.state.productFilter}
            selectedProductId={this.state.productId} 
            onSelectionChange={this.handleSetSelection}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "products":
        return this.buildPanels(List(["productFilter", ProductPropertiesPanel, BundledProductsPanel]));
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "productFilter":
        return <FilterPanel
          key="ProductFilterPanel"
          title="Product Filter"
          expanded={true}
          options={productFilterOptions}
          onClick={this.handleSetProductFilter.bind(this)}
          filter={this.state.productFilter}
          />              
      case ProductPropertiesPanel:
        return <ProductPropertiesPanel
                key="ProductPropertiesPanel"
                expanded={true}
                productId={this.state.productId}
                hasSelection={this.state.hasProductSelection}
                />
      case BundledProductsPanel:
        return <BundledProductsPanel
                key="BundledProductsPanel"
                expanded={true}
                active={isBundle(this.state.productType)}
                productId={this.state.productId}
                />
      default:
        return null;      
    }
  }

  handleSetSelection(id, type) {
    this.setState({productId: id, productType: type, hasProductSelection: true});
  }

  handleSetProductFilter(item) {
    this.setState({
      productFilter: item.get("id")
    });
  }    

  handleCreateProduct() {
    this.props.requestCreateProduct();
  }

  handleChangeDescription() {
    if (isBundle(this.state.productType)) {
      this.props.requestChangeProductBundleDescription(this.state.productId);
    } else {
      this.props.requestChangeProductDescription(this.state.productId);
    }
  }

  handleChangeMeasurements() {
    this.props.requestChangeProductMeasurements(this.state.productId);
  }

  handleCreateBundle() {
    this.props.requestCreateProductBundle();
  }

  handleAddToBundle() {
    this.props.requestAddProductToBundle(this.state.productId);
  }

  handleRemoveFromBundle() {
    this.props.requestRemoveProductFromBundle(this.state.productId);
  }

}

export default ProductsPage;